import React from 'react';
import { Layout } from 'antd';

const { Footer: AntFooter } = Layout;
const OPEN_PRIVACY_EVENT = 'datatek:open-rm-privacy';

const Footer = () => {
  return (
    <AntFooter style={{ textAlign: 'center' }}>
      <div className="rm-footer-inner">
        <strong>datatek, spol. s r. o.</strong>
        <span aria-hidden>·</span>
        <span>Doležalova 3424/15C, 821 04 Bratislava</span>
        <span aria-hidden>·</span>
        <span>
          e-mail:{' '}
          <a href="mailto:support@datatek.sk">support@datatek.sk</a>
        </span>
        <span aria-hidden>·</span>
        <span>
          tel.:{' '}
          <a href="tel:+421904701397">+421 904 701 397</a>
        </span>
        <span aria-hidden>·</span>
        <button
          type="button"
          className="rm-privacy-footer-btn"
          onClick={() => window.dispatchEvent(new CustomEvent(OPEN_PRIVACY_EVENT))}
        >
          Informácia o súkromí
        </button>
      </div>
    </AntFooter>
  );
};

export default Footer;
export { OPEN_PRIVACY_EVENT };
